module.exports = __webpack_public_path__ + "img/C2_HQ02.6b87834d.jpg";